import SplashLoader from '@components/atoms/SplashLoader';
import { Stack } from '@mui/material';
import React, { createContext, useContext, useState } from 'react';

interface LoaderContextType {
  showLoader: VoidFunction;
  hideLoader: VoidFunction;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export function LoaderProvider({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);

  const showLoader = () => setIsLoading(true);
  const hideLoader = () => setIsLoading(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {isLoading && (
        <Stack
          style={{
            background: 'white',
            position: 'fixed',
            height: '100vh',
            width: '100vw',
            alignItems: 'center',
            zIndex: 100,
          }}
        >
          <SplashLoader />
        </Stack>
      )}
      {children}
    </LoaderContext.Provider>
  );
}

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within LoaderProvider');
  }
  return context;
};
